const PROVIDERS_COLORS = {
  custom:   '#E63B8F',
  mapbox:   '#39ADCC',
  google:   '#34A853',
  mapQuest: '#FBBC05',
  bing:     '#8268FB',
  skobbler: '#2d63ed',
  default:  '#444444'
};

export default PROVIDERS_COLORS;